import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, ChevronLeft } from 'lucide-react';

export const AdminHomeButton = () => {
  const { pathname } = useLocation();

  const isAdminSubPage =
    pathname.startsWith('/admin/') && pathname !== '/admin/';

  if (!isAdminSubPage) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-background/90 backdrop-blur border-b border-border/60">
      <div className="container mx-auto px-4 max-w-7xl">
        <Link
          to="/admin"
          className="inline-flex items-center gap-1.5 py-1.5 text-xs font-medium text-muted-foreground hover:text-primary transition-colors"
        >
          <ChevronLeft className="h-3.5 w-3.5" />
          <LayoutDashboard className="h-3 w-3" />
          Admin Console
        </Link>
      </div>
    </div>
  );
};
